import { computedFrom, autoinject } from 'aurelia-framework';
import { DialogController } from "aurelia-dialog";
import { WebApiService } from "../../services/web-api-service";
import { BusyService } from "../../services/busy-service";
import { SecurityService } from "../../services/security-service";
import { PageMessageService } from "../../services/page-message-service";
import { AppMessageService } from "../../services/app-message-service";
import { Contact } from "../../models/contact";
import 'jquery';
import 'notify';
import { ContactPhone } from '../../models/contact-phone';
import { PageMessage } from '../../resources/elements/page-message';

@autoinject
export class UpdateContactDialog {
    constructor(
        protected controller: DialogController,
        private busyService: BusyService,
        private securityService: SecurityService,
        private appMessageService: AppMessageService,
        private pageMessageService: PageMessageService,
        private api: WebApiService
    ) {
        this.appMessageService.containerId = "update-contact-dialog";
    }

    contact: Contact = new Contact();
    contactPhones: Array<ContactPhone> = [];
    deletedPhones: Array<ContactPhone> = [];
    allMills: Array<any> = [];
    showMills: Boolean = true;
    allSelected: Boolean = false;
    allContactTypesSelected: Boolean = false;
    nameElement: HTMLElement;
    contactTypes: Array<any> = [];

    @computedFrom("contactTypes.length")
    get filteredContactTypes(): Array<any> {
        return this.contactTypes.filter(o => {
            if (o.carrier == true) {
                if (this.securityService.hasRole("edit")) {
                    return true;
                } else {
                    return o.id != 1 && o.id != 2;
                }
            }
        });
    }

    private savedLastVerified: Date;

    @computedFrom("contact.lastVerified", "contact.lastVerifiedBy")
    get lastVerifiedBy(): string {

        if (!this.contact || !this.contact.lastVerified) {
            return "";
        }

        if (JSON.stringify(this.contact.lastVerified) != JSON.stringify(this.savedLastVerified)) {
            return this.securityService.user.userName;
        }
        return this.contact.lastVerifiedBy;
    }

    //an aray of mill codes (populated when the contact loads and bound to the mill list selection box)
    contactMills: Array<any> = [];

    async activate(model) {

        this.allMills = model.mills;
        this.deletedPhones = [];

        if (model.showMills != undefined) {
            this.showMills = model.showMills;
        }

        //defaults for a new contact
        if (!model.contact) {
            this.contact = new Contact();
            this.contact.carrierId = model.carrierId;

            if (this.allMills) {
                //default selection to all mills
                this.contact.mills = this.getAllMillsString();
                this.contactMills = this.getAllMillCodes();
            }
        } else {
            //if millIds == null, then that means they're all selected.
            //populate with all mills so that the control displays them as all selected.

            // get a new copy so that the original is not modified
            this.contact = await this.getCarrierContact(model.contact.id);

            if (this.allMills) {
                if (!this.contact.mills) {
                    this.contact.mills = this.getAllMillsString();
                    this.contactMills = this.getAllMillCodes();
                } else {
                    this.contactMills = this.contact.mills.split(',');
                }
            }
        }

        await this.loadContactTypes();
    }

    getAllMillCodes() {
        if (this.allMills) {
            return this.allMills.map((item) => item.millId);
        }
        return [];
    }

    getAllMillsString() {
        return this.getAllMillCodes().join(',');
    }

    attached() {
        var stuff = (<any>$(".info-tooltip"));
        stuff.popover();
        
        this.nameElement.focus();
    }

    async loadContactTypes() {
        const result = await this.api.get("Carriers", "GetContactTypes")
        const contactTypes = JSON.parse(result.response);
        this.contactTypes = contactTypes.filter(o => o.carrier == true);
    }

    verifyToday() {
        this.contact.lastVerified = new Date();
    }

    async getCarrierContact(contactId: number) {
        try {
            let result = await this.api.get("Carriers", "GetCarrierContact", { contactId: contactId });
            let contact = JSON.parse(result.response) as Contact;
            if (contact.lastVerified) {
                this.savedLastVerified = contact.lastVerified = new Date(contact.lastVerified + "Z");
            }
            return contact;
        } catch (e) {
            alert("Error loading contact: " + e);
        }
    }
    removePhone(phone: ContactPhone) {
        if (phone.contactPhoneId) {
            this.deletedPhones.push(phone);
        }
        let indexToRemove = this.contact.phones.findIndex(o => o == phone);
        if (indexToRemove > -1) {
            this.contact.phones.splice(indexToRemove, 1);
        }
    }
    addPhone() {
        if (!this.contact.phones.find(o => !o.contactPhoneId)) {
            this.contact.phones.push(new ContactPhone());
        }
    }

    delete() {
        var params = this.buildContactModel();

        this.pageMessageService.clear();
        this.api.post("Carriers", "DeleteCarrierContact", params)
            .then(() => {
                $["notify"]("Contact deleted", { className: "success", position: "top center" });
                this.controller.ok();
            }, () => {
                $["notify"]("Error saving contact", { className: "error", position: "top center" });
            });
    }

    save(asCopy) {

        //save contacts immediately
        //requires a valid carrierId
        if (this.contact.carrierId == 0) {
            throw new Error("Cannot save contacts until the carrier has been saved.");
        }

        //ensure that contact type is selected
        if (!this.contact.contactTypeIds.length) {
            alert("Please select at least one Contact Type");
            return;
        }

        //ensure that last verified is a date and is not a future date
        if (this.contact.lastVerified)
            if (new Date(this.contact.lastVerified).toString() == "Invalid Date") {
                alert("Last Verified must be a valid date.");
                return;
            } else {
                var today = new Date(new Date().toDateString());
                var verifiedDate = new Date(new Date(this.contact.lastVerified).toDateString());
                if (today < verifiedDate) {
                    alert("Last Verified cannot be a future date.");
                    return;
                }
            }

        //ensure that contact name is specified
        if (!this.contact.name) {
            alert("Please enter Name for the contact.");
            return;
        }


        var params = {
            contact: this.buildContactModel(asCopy),
            deletedPhones: this.deletedPhones
        };
        this.pageMessageService.clear();
        this.api.post("Carriers", "UpdateCarrierContact", params)
            .then(() => {
                if (!this.contact.id) {
                    this.appMessageService.addSuccessMessage("Contact created");
                } else {
                    this.appMessageService.addSuccessMessage("Contact updated");
                }
                this.controller.ok();
            }, () => {
                this.appMessageService.addErrorMessage("Error saving contact");
            });
    }

    buildContactModel(asCopy = false) {
        var contactId = asCopy ? 0 : this.contact.id;
        var phones = this.contact.phones;
        if (asCopy) {
            phones = this.contact.phones.map(o => {
                var ph = ContactPhone.clone(o);
                ph.contactPhoneId = 0;
                return ph;
            });
        }

        return {
            id: contactId,
            carrierId: this.contact.carrierId,
            name: this.contact.name,
            title: this.contact.title,
            lastVerified: this.contact.lastVerified,
            lastVerifiedBy: this.lastVerifiedBy,
            email: this.contact.email,
            phones: phones,
            mills: this.allSelected ? null : this.contactMills.join(','),
            allMills: this.getAllMillsString(),
            contactTypeIds: this.contact.contactTypeIds,
            city: this.contact.city,
            state: this.contact.state,
            receiveAccountingReports: this.contact.receiveAccountingReports,
            receiveDispatchReports: this.contact.receiveDispatchReports
        };
    }


}